import React from 'react';
import './FullScreenLoader.css';

interface FullScreenLoaderProps {
  visible: boolean;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="fullscreen-loader">
      <div className="spinner" />
    </div>
  );
};

export default FullScreenLoader;
